export default __webpack_public_path__ + "static/p3-47cb041d2d352a16d840cad8eba04a0f.png";